export default function convertMomentFormatToCSharp(momentFormat) {
	const tokenMap = {
		"YYYY": "yyyy",
		"YY": "yy",
		"MMMM": "MMMM",
		"MMM": "MMM",
		"MM": "MM",
		"M": "M",
		"DD": "dd",
		"D": "d",
		"HH": "HH",
		"hh": "hh",
		"mm": "mm",
		"ss": "ss",
		"A": "tt",
		"a": "tt"
	};

	// Iterate over the token map and replace Moment.js tokens with C# specifiers
	for (const [momentToken, csharpToken] of Object.entries(tokenMap)) {
		momentFormat = momentFormat.replace(new RegExp(momentToken, 'g'), csharpToken);
	}

	return momentFormat;
}
